// extracted by mini-css-extract-plugin
export default {"tabsContent":"QjVfksu3VbvyQUtnWiq_","hidden":"xzx0CsZ390KFiuKn1ttH","active":"CdbJ_OuXpFlt_wF4s4Mz"};